import React, { useRef, useState } from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import {
  Drawer,
  TextInputWithLabel,
  Button,
  FileUploader,
  Loader
} from 'quantux-ui';
import { Cropper } from 'react-cropper';
import { BASE_URL } from '../../utils';
import { blue, gray, salmon } from '../../theme';

const CompanyEditProfileDrawer = (props) => {
  // -- Props -----------------------------------------------------------
  const {
    userName: userNameProp = '',
    displayName: displayNameProp = '',
    avatarImageUrl: avatarImageUrlProp = 'https://quantumtrader.s3.amazonaws.com/defaultAvatar.svg',
    bannerImageUrl: bannerImageUrlProp = 'https://quantumtrader.s3.amazonaws.com/defaultBanner.svg',
    profileDescription: profileDescriptionProp = '',
    email: emailProp = '',
    phone: phoneProp = '',
    fax: faxProp = '',
    mailingAddress: mailingAddressProp = {},
    companyName: companyNameProp = '',
    website: websiteProp = ''
  } = props.companyData;

  const {
    streetAddress1: streetAddressProp = '',
    suite: suiteProp = '',
    city: cityProp = '',
    state: stateProp = '',
    zip: zipProp = ''
  } = mailingAddressProp;

  console.log(props);

  // -- State vars ------------------------------------------------------
  const [bannerImageUrl, setBannerImageUrl] = useState(bannerImageUrlProp);
  const [avatarImageUrl, setAvatarImageUrl] = useState(avatarImageUrlProp);
  const [companyName, setCompanyName] = useState(companyNameProp);
  const [displayName, setDisplayName] = useState(displayNameProp);
  const [isDisplayNameValid, setIsDisplayNameValid] = useState(false);
  const [isDisplayNamePristine, setIsDisplayNamePristine] = useState(true);
  const [userName, setUserName] = useState(userNameProp);
  const [isUserNameValid, setIsUserNameValid] = useState(false);
  const [isUserNamePristine, setIsUserNamePristine] = useState(true);
  const [isUserNameDuplicate, setIsUserNameDuplicate] = useState(true);
  const [profileDescription, setProfileDescription] = useState(profileDescriptionProp);
  const [streetAddress1, setStreetAddress1] = useState(streetAddressProp);
  const [suite, setSuite] = useState(suiteProp);
  const [city, setCity] = useState(cityProp);
  const [state, setState] = useState(stateProp);
  const [zip, setZip] = useState(zipProp);
  const [email, setEmail] = useState(emailProp);
  const [isEmailPristine, setIsEmailPristine] = useState(true);
  const [isEmailValid, setIsEmailValid] = useState(false);
  const [isEmailDuplicate, setIsEmailDuplicate] = useState(true);
  const [phone, setPhone] = useState(phoneProp);
  const [isPhonePristine, setIsPhonePristine] = useState(true);
  const [isPhoneValid, setIsPhoneValid] = useState(false);
  const [fax, setFax] = useState(faxProp);
  const [website, setWebsite] = useState(websiteProp);
  // -- Drawer Types
  const [showProfileDrawer, setShowProfileDrawer] = useState(true);
  const [showBannerDrawer, setShowBannerDrawer] = useState(false);
  const [showAvatarDrawer, setShowAvatarDrawer] = useState(false);
  // -- Banner and Avatar Drawers
  const [isBannerUploading, setIsBannerUploading] = useState(false);
  const [isAvatarUploading, setIsAvatarUploading] = useState(false);
  const [showBannerCropper, setShowBannerCropper] = useState(false);
  const [showAvatarCropper, setShowAvatarCropper] = useState(false);

  // -- Refs ------------------------------------------------------------
  const drawerBannerRef = useRef();
  const bannerCropperRef = useRef();
  const bannerFileInputRef = useRef();
  const drawerAvatarRef = useRef();
  const avatarCropperRef = useRef();
  const avatarFileInputRef = useRef();

  const styles = StyleSheet.create({
    drawerContainer: {
      background: '#002448',
      color: gray[300],
      height: '100%',
      position: 'relative',
      display: 'flex',
      flexFlow: 'column'
    },
    drawerHeader: {
      height: '40px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 8px',
      fontWeight: 'bold',
      borderBottom: '1px solid black',
      flexShrink: '0'
    },
    drawerHeaderCloseIcon: {
      color: gray[300],
      ':hover': {
        color: salmon[500]
      }
    },
    drawerBanner: {
      position: 'relative',
      padding: '8px 0 0 2px',
      flexShrink: '0'
    },
    drawerBannerImg: {
      width: '100%',
      height: 'auto'
    },
    drawerBannerCameraIcon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: gray[500],
      color: 'white',
      position: 'absolute',
      right: '0',
      bottom: '8px',
      fontSize: '11px',
      width: '24px',
      height: '24px',
      cursor: 'pointer',
      borderRadius: '50%'
    },
    drawerContentArea: {
      overflowY: 'auto',
      color: gray[300],
      flexGrow: '1'
    },
    drawerUserCardAvatar: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '80px',
      height: '80px',
      color: 'white',
      borderRadius: '4px',
      position: 'relative'
    },
    drawerUserCardAvatarImg: {
      width: 'auto',
      height: '80px',
      maxHeight: '80px'
    },
    drawerAvatarCamera: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: gray[500],
      color: 'white',
      position: 'absolute',
      left: '-3px',
      top: '58px',
      fontSize: '11px',
      width: '24px',
      height: '24px',
      cursor: 'pointer',
      borderRadius: '50%'
    },
    drawerUserCardText: {
      fontSize: '12px'
    },
    profileTextAreaContainer: {
      paddingRight: '8px'
    },
    profileTextArea: {
      width: '100%',
      background: gray[900],
      height: '100px',
      color: gray[100],
      border: 'none',
      resize: 'none',
      overflow: 'auto',
      fontFamily: 'inherit',
      ':focus': {
        outlineColor: 'transparent',
        outlineStyle: 'none'
      }
    },
    drawerFooter: {
      alignItems: 'center',
      justifyContent: 'flex-end',
      background: gray[700],
      height: '56px',
      width: '100%',
      borderTop: `1px solid ${gray[500]}`,
      flexShrink: '0'
    },
    imageUploadLoader: {
      position: 'relative',
      height: '454px',
      top: '-400px',
      background: gray[800]
    },
    criticalSmallText: {
      fontSize: '12px',
      color: salmon[500],
      paddingLeft: '8px',
      fontWeight: 'bold',
      width: '140px'
    }
  });

  // #region Profile Drawer Handlers
  const handleOnEditCompanyName = (e) => {
    const { value } = e.target;
    setCompanyName(value);
  };

  const handleOnEditDisplayName = (e) => {
    const { value } = e.target;
    setDisplayName(value);
  };

  const handleOnEditUserName = (e) => {
    const { value } = e.target;
    setUserName(value);
  };

  const handleOnEditStreetAddress = (e) => {
    const { value } = e.target;
    setStreetAddress1(value);
  };

  const handleOnEditSuite = (e) => {
    const { value } = e.target;
    setSuite(value);
  };

  const handleOnEditCity = (e) => {
    const { value } = e.target;
    setCity(value);
  };

  const handleOnEditState = (e) => {
    const { value } = e.target;
    setState(value);
  };

  const handleOnEditZip = (e) => {
    const { value } = e.target;
    setZip(value);
  };

  const handleOnEditEmail = (e) => {
    const { value } = e.target;
    setEmail(value);
  };

  const handleOnEditPhone = (e) => {
    const { value } = e.target;
    setPhone(value);
  };

  const handleOnEditFax = (e) => {
    const { value } = e.target;
    setFax(value);
  };

  const handleOnEditWebsite = (e) => {
    const { value } = e.target;
    setWebsite(value);
  };

  const handleOnChangeProfileDescription = (e) => {
    const { value } = e.target;
    setProfileDescription(value);
  };

  const handleOnClickSaveCompanyProfile = () => {
    const myHeaders = new Headers();
    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formData = new FormData();
    formData.append('companyId', props.companyData._id);
    formData.append('companyName', companyName);
    formData.append('displayName', displayName);
    formData.append('userName', userName);
    formData.append('streetAddress', streetAddress1);
    formData.append('suite', suite);
    formData.append('city', city);
    formData.append('state', state);
    formData.append('zip', zip);
    formData.append('email', email);
    formData.append('phone', phone);
    formData.append('fax', fax);
    formData.append('website', website);
    formData.append('avatarImageUrl', avatarImageUrl);
    formData.append('bannerImageUrl', bannerImageUrl);
    formData.append('profileDescription', profileDescription);

    const requestOptions = {
      method: 'PUT',
      headers: myHeaders,
      body: formData,
      redirect: 'follow'
    };

    fetch(`${BASE_URL}/company/update`, requestOptions)
      .then(response => response.text())
      .then(result => {
        const res = JSON.parse(result);
        if (res.success) {
          props.updateData();
          props.onClose();
        }
      })
      .catch(error => console.log('error', error));
  };
  // #endregion

  // #region Banner Upload Drawer
  const uploadBanner = () => {
    const formData = new FormData();
    const img = bannerFileInputRef.current.files[0];
    formData.append('file', img);
    const options = { method: 'POST', body: formData, redirect: 'follow' };

    fetch(`${BASE_URL}/users/uploadImg`, options)
      .then(response => response.text())
      .then(result => {
        const res = JSON.parse(result);
        // console.log(res);
        if (res.success) {
          setBannerImageUrl(res.fileUrl);
          setIsBannerUploading(false);
          setShowBannerCropper(true);
        }
      })
      .catch(error => console.log('error', error));
  };

  const uploadCroppedBanner = (blob) => {
    const formData = new FormData();
    formData.append('file', blob, 'croppedBanner.png');
    const options = { method: 'POST', body: formData, redirect: 'follow' };

    fetch(`${BASE_URL}/users/uploadImg`, options)
      .then(response => response.text())
      .then(result => {
        const res = JSON.parse(result);
        // console.log(res);
        if (res.success) {
          // console.log('Cropped banner image url', res.fileUrl);
          setBannerImageUrl(res.fileUrl);
        }
      })
      .catch(error => console.log('error', error));
  };

  const handleOnBannerFileDrop = (img) => {
    const formData = new FormData();
    formData.append('file', img);
    const options = { method: 'POST', body: formData, redirect: 'follow' };
    setIsBannerUploading(true);
    fetch(`${BASE_URL}/users/uploadImg`, options)
      .then(response => response.text())
      .then(result => {
        const res = JSON.parse(result);
        // console.log(res);
        if (res.success) {
          setBannerImageUrl(res.fileUrl);
          setIsBannerUploading(false);
          setShowBannerCropper(true);
        }
      })
      .catch(error => console.log('error', error));
  };

  const handleOnBannerFileSelected = () => {
    if (bannerFileInputRef.current.files.length > 0) {
      setIsBannerUploading(true);
      uploadBanner();
    } else {
      console.log('No file is selected!');
    }
  };

  const handleOnClickBannerCrop = () => {
    const imageElement = bannerCropperRef.current;
    const { cropper } = imageElement;
    cropper.getCroppedCanvas().toBlob((blob) => {
      const url = URL.createObjectURL(blob);
      drawerBannerRef.current.src = url;
      uploadCroppedBanner(blob);
      setShowBannerDrawer(false);
    });
  };
  // #endregion

  // #region Avatar Upload Drawer
  const uploadAvatar = () => {
    const formData = new FormData();
    const img = avatarFileInputRef.current.files[0];
    formData.append('file', img);
    const options = { method: 'POST', body: formData, redirect: 'follow' };

    fetch(`${BASE_URL}/users/uploadImg`, options)
      .then(response => response.text())
      .then(result => {
        const res = JSON.parse(result);
        // console.log(res);
        if (res.success) {
          setAvatarImageUrl(res.fileUrl);
          setIsAvatarUploading(false);
          setShowAvatarCropper(true);
        }
      })
      .catch(error => console.log('error', error));
  };

  const uploadCroppedAvatar = (blob) => {
    const formData = new FormData();
    formData.append('file', blob);
    const options = { method: 'POST', body: formData, redirect: 'follow' };

    fetch(`${BASE_URL}/users/uploadImg`, options)
      .then(response => response.text())
      .then(result => {
        const res = JSON.parse(result);
        // console.log(res);
        if (res.success) {
          // console.log('Cropped avatar image url', res.fileUrl);
          setAvatarImageUrl(res.fileUrl);
        }
      })
      .catch(error => console.log('error', error));
  };

  const handleOnAvatarFileDrop = (img) => {
    const formData = new FormData();
    formData.append('file', img);
    const options = { method: 'POST', body: formData, redirect: 'follow' };
    setIsAvatarUploading(true);
    fetch(`${BASE_URL}/users/uploadImg`, options)
      .then(response => response.text())
      .then(result => {
        const res = JSON.parse(result);
        // console.log(res);
        if (res.success) {
          setAvatarImageUrl(res.fileUrl);
          setIsAvatarUploading(false);
          setShowAvatarCropper(true);
        }
      })
      .catch(error => console.log('error', error));
  };

  const handleOnAvatarFileSelected = () => {
    if (avatarFileInputRef.current.files.length > 0) {
      setIsAvatarUploading(true);
      uploadAvatar();
    } else {
      console.log('No file is selected!');
    }
  };

  const handleOnClickAvatarCrop = () => {
    const imageElement = avatarCropperRef.current;
    const { cropper } = imageElement;
    cropper.getCroppedCanvas().toBlob((blob) => {
      const url = URL.createObjectURL(blob);
      drawerAvatarRef.current.src = url;
      uploadCroppedAvatar(blob);
      setShowAvatarCropper(false);
    });
  };
  // #endregion

  return (
    <div>
      {/* Profile Drawer */}
      {showProfileDrawer &&
        <Drawer
          placement="right"
          visible={showProfileDrawer}
          toggleDrawer={props.onClose}
          zIndex="2000"
          width={window.innerWidth <= 700 ? window.innerWidth : 358}
        >
          <div className={css(styles.drawerContainer)}>
            {/* Header */}
            <div className={css(styles.drawerHeader)}>
              <div className='fx fx__hv-center'>
                <i className='mr-2 fa fa-lg fa-building' />
                <div className='noselect'>Update Company Profile</div>
              </div>
              <i
                className={`fa fa-lg fa-times-circle ${css(styles.drawerHeaderCloseIcon)}`}
                onClick={props.onClose}
              />
            </div>
            {/* Middle Area */}
            <div className={css(styles.drawerContentArea)}>
              <div className='p-2'>
                {/* Banner */}
                <div className={css(styles.drawerBanner)}>
                  <img
                    ref={drawerBannerRef}
                    src={bannerImageUrl}
                    alt="cropped-banner"
                    className={css(styles.drawerBannerImg)}
                  />
                  {/* Camera icon */}
                  <div
                    onClick={() => { setShowBannerDrawer(true); }}
                    className={css(styles.drawerBannerCameraIcon)}
                  >
                    <i className="fa fa-camera" />
                  </div>
                </div>
                <div>
                  {/* Company Name */}
                  <div>
                    <TextInputWithLabel
                      value={companyName}
                      titleText='Company Name'
                      titleFontSize={12}
                      isCompactLayout={true}
                      titleColor={gray[200]}
                      textColor="white"
                      selectionColor="white"
                      selectionBackground="#0080FF"
                      spellcheck={false}
                      width={342}
                      onChange={handleOnEditCompanyName}
                    />
                  </div>
                  {/* User card */}
                  <div className="fx mt-4 ml-2">
                    {/* Avatar */}
                    <div className={css(styles.drawerUserCardAvatar)}>
                      <img
                        src={avatarImageUrl}
                        ref={drawerAvatarRef}
                        alt="avatar"
                        className={css(styles.drawerUserCardAvatarImg)}
                        onClick={() => setShowAvatarDrawer(true)}
                      />
                      <div
                        onClick={() => { setShowAvatarDrawer(true); }}
                        className={css(styles.drawerAvatarCamera)}
                      >
                        <i className="fa fa-camera" />
                      </div>
                    </div>
                    {/* User card displayName & userName */}
                    <div className={`ml-2 ${css(styles.drawerUserCardText)}`}>
                      {/* Display Name */}
                      <div style={{ marginTop: '-5px' }}>
                        <TextInputWithLabel
                          value={displayName}
                          titleText="Display Name (2 to 40 characters)*"
                          titleFontSize={12}
                          isCompactLayout={true}
                          titleColor={gray[200]}
                          textColor="white"
                          selectionColor="white"
                          selectionBackground="#0080FF"
                          spellcheck={false}
                          width={248}
                          onChange={handleOnEditDisplayName}
                        />
                        {/* Error message */}
                        {!isDisplayNameValid && !isDisplayNamePristine
                          ? <div className={css(styles.errMsg)}>
                            Invalid Display Name
                          </div>
                          : null
                        }
                      </div>
                      {/* UserName */}
                      <div
                        style={{
                          marginTop: (!isDisplayNameValid && !isDisplayNamePristine) ? '0px' : '4px'
                        }}
                      >
                        <TextInputWithLabel
                          value={userName}
                          titleText="Username (2 to 20 characters, no spaces)*"
                          titleFontSize={12}
                          isCompactLayout={true}
                          titleColor={gray[200]}
                          textColor={blue[500]}
                          selectionColor="white"
                          selectionBackground="#0080FF"
                          spellcheck={false}
                          width={248}
                          onChange={handleOnEditUserName}
                        />
                        {/* Error message */}
                        {!isUserNameValid && !isUserNamePristine
                          ? <div className={css(styles.errMsg)}>
                            Invalid User Name
                          </div>
                          : null
                        }
                        {isUserNameValid && !isUserNamePristine && isUserNameDuplicate
                          ? <div className={css(styles.errMsg)}>
                            User Name Taken
                          </div>
                          : null
                        }
                      </div>
                    </div>
                  </div>
                  {/* Mailing Address, Email, Phone, Fax, Profile description & Website */}
                  <div className="mt-4 ml-2">
                    {/* Heading */}
                    <div className="fx fx__v-center">
                      <i className="fa fa-map-marker" style={{ fontSize: '22px' }} />
                      <div className="ml-1">
                        Mailing Address
                      </div>
                    </div>
                    {/* Form */}
                    <div>
                      {/* Address */}
                      <div className="fx">
                        <div>
                          <TextInputWithLabel
                            value={streetAddress1}
                            titleText="Street"
                            titleFontSize={12}
                            isCompactLayout={true}
                            titleColor={gray[200]}
                            textColor="white"
                            selectionColor="white"
                            selectionBackground="#0080FF"
                            spellcheck={false}
                            width={284}
                            onChange={handleOnEditStreetAddress}
                          />
                        </div>
                        <div className="ml-2">
                          <TextInputWithLabel
                            value={suite}
                            titleText="Suite"
                            titleFontSize={12}
                            isCompactLayout={true}
                            titleColor={gray[200]}
                            textColor="white"
                            selectionColor="white"
                            selectionBackground="#0080FF"
                            spellcheck={false}
                            width={45}
                            onChange={handleOnEditSuite}
                          />
                        </div>
                      </div>
                      {/* City, State and Zip */}
                      <div className="fx mt-2">
                        <div>
                          <TextInputWithLabel
                            value={city}
                            titleText="City"
                            titleFontSize={12}
                            isCompactLayout={true}
                            titleColor={gray[200]}
                            textColor="white"
                            selectionColor="white"
                            selectionBackground="#0080FF"
                            spellcheck={false}
                            width={230}
                            onChange={handleOnEditCity}
                          />
                        </div>
                        <div className="ml-2">
                          <TextInputWithLabel
                            value={state}
                            titleText="State"
                            titleFontSize={12}
                            isCompactLayout={true}
                            titleColor={gray[200]}
                            textColor="white"
                            selectionColor="white"
                            selectionBackground="#0080FF"
                            spellcheck={false}
                            width={45}
                            onChange={handleOnEditState}
                          />
                        </div>
                        <div className="ml-2">
                          <TextInputWithLabel
                            value={zip}
                            titleText="Zip"
                            titleFontSize={12}
                            isCompactLayout={true}
                            titleColor={gray[200]}
                            textColor="white"
                            selectionColor="white"
                            selectionBackground="#0080FF"
                            spellcheck={false}
                            width={45}
                            onChange={handleOnEditZip}
                          />
                        </div>
                      </div>
                      {/* Email */}
                      <div className="mt-2">
                        <TextInputWithLabel
                          value={email}
                          titleText="Email*"
                          titleFontSize={12}
                          isCompactLayout={false}
                          titleColor={gray[200]}
                          textColor="white"
                          selectionColor="white"
                          selectionBackground="#0080FF"
                          spellcheck={false}
                          width={337}
                          showPreIcon
                          preIcon='fa fa-envelope'
                          onChange={handleOnEditEmail}
                        />
                        {!isEmailPristine && !isEmailValid
                          ? <div className={css(styles.errMsg)}>Invalid Email</div>
                          : null
                        }
                        {isEmailValid && !isEmailPristine && isEmailDuplicate
                          ? <div className={css(styles.errMsg)}>Email already in use</div>
                          : null
                        }
                      </div>
                      {/* Phone */}
                      <div className="mt-2">
                        <TextInputWithLabel
                          value={phone}
                          titleText="Phone #*"
                          titleFontSize={12}
                          isCompactLayout={false}
                          titleColor={gray[200]}
                          textColor="white"
                          selectionColor="white"
                          selectionBackground="#0080FF"
                          spellcheck={false}
                          width={337}
                          showPreIcon
                          preIcon='fa fa-phone'
                          onChange={handleOnEditPhone}
                        />
                        {!isPhonePristine && !isPhoneValid
                          ? <div className={css(styles.errMsg)}>Invalid Phone #</div>
                          : null
                        }
                      </div>
                      {/* Fax */}
                      <div className="mt-2">
                        <TextInputWithLabel
                          value={fax}
                          titleText="Fax #"
                          titleFontSize={12}
                          isCompactLayout={false}
                          titleColor={gray[200]}
                          textColor="white"
                          selectionColor="white"
                          selectionBackground="#0080FF"
                          spellcheck={false}
                          width={337}
                          showPreIcon
                          preIcon='fa fa-fax'
                          onChange={handleOnEditFax}
                        />
                      </div>
                      {/* Website */}
                      <div className="mt-2">
                        <TextInputWithLabel
                          value={website}
                          titleText="Website"
                          titleFontSize={12}
                          isCompactLayout={false}
                          titleColor={gray[200]}
                          textColor="white"
                          selectionColor="white"
                          selectionBackground="#0080FF"
                          spellcheck={false}
                          width={337}
                          showPreIcon
                          preIcon='fa fa-globe'
                          onChange={handleOnEditWebsite}
                        />
                      </div>
                    </div>
                  </div>
                  {/* Profile descriptiom */}
                  <div className="mt-4 ml-2">
                    <div>Profile Description</div>
                    <div className={css(styles.profileTextAreaContainer)}>
                      <textarea
                        className={css(styles.profileTextArea)}
                        placeholder="Write a description"
                        value={profileDescription}
                        onChange={handleOnChangeProfileDescription}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Footer */}
            <div className={`fx pr-2 ${css(styles.drawerFooter)}`} >
              <Button
                btnType="primary"
                className="fx fx__hv-center"
                onClick={handleOnClickSaveCompanyProfile}
                // isDisabled={!canAddCompany}
                style={{
                  height: '32px',
                  width: '340px',
                  padding: '3px 0'
                }}
              >
                Update Company Profile
              </Button>
            </div>
          </div>
        </Drawer>
      }
      {/* Banner Cropper Drawer */}
      {showBannerDrawer &&
        <Drawer
          placement="right"
          visible={showBannerDrawer}
          toggleDrawer={() => setShowBannerDrawer(false)}
          zIndex="2050"
          width={window.innerWidth <= 700 ? window.innerWidth : 358}
        >
          <div className={css(styles.drawerContainer)}>
            {/* Header */}
            <div className={css(styles.drawerHeader)}>
              <div>Upload Profile Banner</div>
              <i
                className={`fa fa-times-circle ${css(styles.drawerHeaderCloseIcon)}`}
                onClick={() => { setShowBannerDrawer(false); }}
              />
            </div>
            {/* Content Area */}
            <div className={css(styles.drawerContentArea, styles.imageUploaderContainer)}>
              {showBannerCropper
                ? <div>
                  <Cropper
                    src={bannerImageUrl}
                    style={{ height: 400, width: '100%' }}
                    checkCrossOrigin
                    checkOrientation={false}
                    aspectRatio={6}
                    background={false}
                    viewMode={1}
                    autoCropArea={1}
                    guides={false}
                    ref={bannerCropperRef}
                  />
                </div>
                : null
              }
              {!showBannerCropper
                ? <div>
                  <FileUploader
                    title='Select File'
                    parentRef={bannerFileInputRef}
                    onDrop={handleOnBannerFileDrop}
                    onChange={handleOnBannerFileSelected}
                  />
                </div>
                : null
              }
              {isBannerUploading
                ? <div className={css(styles.imageUploadLoader)}>
                  <Loader iconType="cog" iconSize="5x" text="Uploading Banner Image" />
                </div>
                : null
              }
            </div>
            {/* Drawer footer area */}
            <div
              className={`fx pr-2 ${css(styles.drawerFooter)}`}
              style={{ position: 'absolute', bottom: '0' }}
            >
              <Button
                btnType="primary"
                className="fx fx__hv-center"
                onClick={handleOnClickBannerCrop}
                style={{
                  height: '32px',
                  width: '340px',
                  padding: '3px 0'
                }}
              >
                Crop Banner Image
              </Button>
            </div>
          </div>
        </Drawer>
      }
      {/* Avatar Cropper Drawer */}
      {showAvatarDrawer &&
        <Drawer
          placement="right"
          visible={showAvatarDrawer}
          toggleDrawer={() => setShowAvatarDrawer(false)}
          zIndex="2050"
          width={window.innerWidth <= 700 ? window.innerWidth : 358}
        >
          <div className={css(styles.drawerContainer)}>
            {/* Header */}
            <div className={css(styles.drawerHeader)}>
              <div>Upload Profile Avatar</div>
              <i
                className={`fa fa-times-circle ${css(styles.drawerHeaderCloseIcon)}`}
                onClick={() => { setShowAvatarDrawer(false); }}
              />
            </div>
            {/* Content Area */}
            <div className={css(styles.drawerContentArea, styles.imageUploaderContainer)}>
              {showAvatarCropper
                ? <div>
                  <Cropper
                    src={avatarImageUrl}
                    style={{ height: 400, width: '100%' }}
                    checkCrossOrigin
                    checkOrientation={false}
                    aspectRatio={1}
                    background={false}
                    viewMode={1}
                    autoCropArea={1}
                    guides={false}
                    ref={avatarCropperRef}
                  />
                </div>
                : null
              }
              {!showAvatarCropper
                ? <div>
                  <FileUploader
                    title='Select File'
                    parentRef={avatarFileInputRef}
                    onDrop={handleOnAvatarFileDrop}
                    onChange={handleOnAvatarFileSelected}
                  />
                </div>
                : null
              }
              {isAvatarUploading
                ? <div className={css(styles.imageUploadLoader)}>
                  <Loader iconType="cog" iconSize="5x" text="Uploading Avatar Image" />
                </div>
                : null
              }
            </div>
            {/* Drawer footer area */}
            <div
              className={`fx pr-2 ${css(styles.drawerFooter)}`}
              style={{ position: 'absolute', bottom: '0' }}
            >
              <Button
                btnType="primary"
                className="fx fx__hv-center"
                onClick={handleOnClickAvatarCrop}
                style={{
                  height: '32px',
                  width: '340px',
                  padding: '3px 0'
                }}
              >
                Crop Avatar Image
              </Button>
            </div>
          </div>
        </Drawer>
      }
    </div>
  );
};

export default CompanyEditProfileDrawer;
